import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const LockedIcon: FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  stroke = '#fff'
}) => {
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        role="img"
        aria-label="Locked"
      >
        <path
          d="M11.335 6.667V5.333a3.333 3.333 0 1 0-6.667 0v1.334m3.333 3V11m-2.133 3h4.267c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-.933c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874c-.428-.218-.988-.218-2.108-.218H5.868c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v.933c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218"
          stroke={stroke}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { LockedIcon };
